/* eslint-disable @typescript-eslint/indent */
import { AlertSmsConfig } from '@procedure-steps/alert-sms/alert-sms-config.model';
import { HttpApiRequestConfig } from '@procedure-steps/http-api-request/http-api-request-config.model';
import { IQueryOperator } from '@utils';
import {
  ManageEmployeeConfig,
} from '@customization/models/manage-employee-config.model';

import { CheckStrategy } from '../check-strategy.enum';
import { ContextDynamicProp } from '../context-dynamic-props.model';
import { DataCollectorConfig } from '../data-collector-config.model';
import { Interval } from '../interval.model';


export type ProcedureStepConfig = ContextDynamicPropsConfig
  | InputTextConfig
  | SessionTitleConfig
  | QuestionsTrueFalseConfig
  | AnswersConfig
  | ExternalWsConfig
  | OutcomeConfig
  | ConditionConfig
  | InputScannerConfig
  | InnerProcedureConfig
  | EnablingsConfig
  | CheckEnablingsConfig
  | InputFileConfig
  | SelectPrevStepConfig
  | ImplicitWorkUnitEnablingsConfig
  | CheckPrevStepValueConfig
  | AlertMailConfig
  | CheckWorkUnitEnablingsConfig
  | HttpApiRequestConfig
  | AlertSmsConfig
  | CreateFileConfig
  | WriteDataConfig

  | ManageEmployeeConfig;

// #region base interfaces
export interface ContextDynamicPropsConfig {
  contextDynamicProps?: ContextDynamicProp[];
}
export interface SelectPrevStepConfig extends ContextDynamicPropsConfig {
  sourceProcedureStepId: number;
}

export interface CheckEnablingsConfig extends ContextDynamicPropsConfig {
  enablingIds: number[];
  checkStrategy: CheckStrategy;
}

// eslint-disable-next-line no-shadow
export enum FileType {
  image = 'image',
  template = 'template',
  attachment = 'attachment'
};
export interface FileConfig {
  path: string;
  fileType: FileType;
  mimeType: string;
  extension: string;
  hash: string;
  filename: string;
  filenameToCreate?: string;
}
export interface FilesConfig {
  files?: FileConfig[];
}

export interface SessionTitleConfig extends ContextDynamicPropsConfig, FilesConfig {
  sessionTitle?: string;
  sessionDescription?: string;
}

// #endregion

export interface WriteDataConfig extends ContextDynamicPropsConfig {
  code: string;
}

export interface CreateFileConfig extends ContextDynamicPropsConfig, FilesConfig { }

export interface InputTextConfig extends SessionTitleConfig {
  rows: number;
  setWorkflowLabel: boolean;
}

export interface AlertMailConfig extends ContextDynamicPropsConfig, FilesConfig {
  subject: string;
  message: string;
  addresses: {
    explicit: string[];
    fromPrevSteps: DataCollectorConfig[];
  };
  attachmentsFromPrevSteps: DataCollectorConfig[];
}

export interface CheckPrevStepValueConfig extends SelectPrevStepConfig {
  op: IQueryOperator;
  queryValue: any;
  checkStrategy: CheckStrategy;
}

export interface QuestionsTrueFalseConfig extends SessionTitleConfig {
  questions: string[];
}
export interface AnswersConfig extends SessionTitleConfig {
  answers: string[];
}
export interface ExternalWsConfig extends SessionTitleConfig {
  wsId: number;
}
export interface OutcomeConfig extends SelectPrevStepConfig {
  result: boolean;
  progress: number;
  defaultOutputValue?: string;
}

export interface ConditionConfig extends ContextDynamicPropsConfig {
  code: string;
  outputValues: string[];
}
export interface InputScannerConfig extends SessionTitleConfig {
  barcodeTypes: string[];
}
export interface InnerProcedureConfig extends ContextDynamicPropsConfig {
  innerProcedureId: number;
}
export interface EnablingsConfig extends SessionTitleConfig {
  enablingConfigs: { enablingId: number; duration: Interval; revoke: boolean }[];
}

export interface InputFileConfig extends SessionTitleConfig {
  maxFiles: number;
}

export interface CheckWorkUnitEnablingsConfig extends SelectPrevStepConfig, CheckEnablingsConfig { }

export interface ImplicitWorkUnitEnablingsConfig extends SelectPrevStepConfig {
  enable: boolean;
}
